import { Button, Dialog } from '@material-ui/core'
import { ReactElement } from 'react'
import * as React from 'react'
import ReactSVG from 'react-svg'
import Tick from '../../assets/img/checkmark.svg'
import styles from './style.module.scss'
import { IProps } from './types'

function SuccessModal({ subtitle, open }: IProps): ReactElement {
  const onClick = () => {
    window.location.href = 'http://onelink.to/pdf758'
  }

  return (
    <Dialog fullScreen={true} open={open}>
      <div className={styles.modal__wrap}>
        <div className={styles.modal}>
          <header className={styles.modal__header}>
            <div className={styles.header}>
              <p className={styles.header__title}>Success!</p>
              <p className={styles.header__subtitle}>
                You can close this tab and go back to the GiantLeap app
              </p>
            </div>
          </header>
          <main className={styles.modal__content}>
            <div className={styles.content}>
              <div className={styles.content__logo}>
                <div className={styles.logo}>
                  <ReactSVG src={Tick} className={styles.logo__tick} />
                </div>
              </div>
              <div className={styles.content__subtitle}>
                <p className={styles.subtitle}>{subtitle}</p>
              </div>
            </div>
          </main>
          <footer className={styles['modal__back-button']}>
            <Button onClick={onClick} className={styles['back-button']}>
              <p className={styles['back-button__text']}>Go back to app</p>
            </Button>
          </footer>
        </div>
      </div>
    </Dialog>
  )
}

export default SuccessModal



// WEBPACK FOOTER //
// ./src/components/SuccessModal/index.tsx